export * from './archive-users-m2m-api-client.service';
import { ArchiveUsersM2mApiClient } from './archive-users-m2m-api-client.service';
export * from './archive-users-m2m-api-client.serviceInterface';
export const APIS = [ArchiveUsersM2mApiClient];
